/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 */
import React from "react";
import { useTranslation } from "react-i18next";
import CustomChip from "../../../components/CustomChip";
import {
    BuildInternalIcon, IconChipMultiplePerson,
} from "../../../components/buttons/IconButtons";
import { status } from "../../../enums/statusEnum";
import { statusBorderColor, statusColor, statusFontColor } from "../../../enums/statusColorEnum";

/**
 * Building card: name with its status chip, the selection checkbox and the
 * actions menu. It replaces the row the buildings list used to render.
 *
 * @param {Object} props - Component properties
 * @param {Object} props.item - Building data to display
 * @param {number} props.index - Position of the card inside the list, used to build the element ids
 * @param {boolean} props.checked - Indicates if the card is selected
 * @param {Function} props.handleCheckboxChange - Handler for the checkbox state changes
 * @param {JSX.Element} [props.actions] - Actions menu rendered on the right side of the card
 * @returns {JSX.Element}
 */
const MyApartmentCard = ({ item, actions }) => {
    const { t } = useTranslation();

    return (
        <div className={'col-12 mb-3 px-0'}>
            <div className={'border-radius-8px background-shades-50 border-full-shades-100 px-2 pb-2'}>
                <div className={'d-flex align-items-center justify-content-between'}>
                    <div className={'d-flex align-items-center flex-grow-1 minw-0'}>
                        <div className={'background-primary-100 p-8px border-radius-8px d-flex justify-content-center mr-8px'}>
                            <BuildInternalIcon/>
                        </div>

                        <div className={'flex-grow-1 minw-0 mr-8px'}>
                            <div className={"d-flex align-items-center"}>
                                <p className="fs-16px ibl-font-w-600">{item?.buildingName} • &nbsp;</p>
                                <p className="fs-14px">{t('apt')} {item?.name}</p>
                            </div>
                            <div className={"d-flex align-items-center"}>
                                <div className={"mr-2"}><IconChipMultiplePerson className={"icon-color-shades-500"}/></div>
                                <p className={"fs-14px font-color-shades-500"}>{item?.totalResident} {t("members")}</p>
                            </div>
                        </div>
                    </div>

                    <div className={'flex-shrink-0 ml-2'}>
                        {actions}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyApartmentCard;
